import APIController from './APIController';
import SyncHelper from '../Helper/SyncHelper';
import {useWebSocket} from "../Context/WebSocketContext";

const Extra = () =>{
    //Requesthelper
    const {basicRequest, jsonRequest, getWorkspaceId} = APIController()
    const {readOffline} = SyncHelper()
    const {isOnline} = useWebSocket()

    const fetchExtras = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return []; 
        if (isOnline === false) return readOffline('extras');
        const data = await jsonRequest(`/${workspaceId}/extra`);
        return data;
    };

    const createExtra = async (extraDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/extra/new`, "POST", extraDTO);
        return data;
    };

    const editExtra = async (id, extraDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/extra/${id}`, "PUT", extraDTO);
        return data;
    };

    const deleteExtra = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/extra/${id}`, "DELETE");
        return data;
    };

    /* Return the api calls and the extra  */
    return {
        fetchExtras,
        createExtra,
        editExtra,
        deleteExtra
    }
}
export default Extra